import { getTextWithoutChildren } from '../../../jquery_plugins/get_text_without_children';

export const getLabelFromLink = linkElement => {
    const originRegExp = new RegExp(location.origin + '/?');
    const { baseUrl } = TYROOLA.globals;
    const href = linkElement.href
        ? linkElement.href.replace(originRegExp, '')
        : 'no href';

    return href === baseUrl
        ? 'Homepage'
        : getTextWithoutChildren($(linkElement));
};
